const styles = {
  form: {
    width: '100%',
    maxWidth: 500,
  },
};

export default styles;
